import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Marquee from "@/components/Marquee";
import HeroVideo from "@/components/HeroVideo";
import Hero from "@/sections/Hero";
import Metrics from "@/sections/Metrics";
import WhyRound from "@/sections/WhyRound";
import Deal from "@/sections/Deal";
import UseOfFunds from "@/sections/UseOfFunds";
import Traction from "@/sections/Traction";
import Product from "@/sections/Product";
import Distribution from "@/sections/Distribution";
import Roadmap from "@/sections/Roadmap";
import Market from "@/sections/Market";
import Team from "@/sections/Team";
import DataRoom from "@/sections/DataRoom";
import NextSteps from "@/sections/NextSteps";

export default function DealRoom() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="grain relative min-h-screen bg-navy-950" data-testid="deal-room">
            <Navbar />
            <main className="relative z-10">
                <Hero />
                <HeroVideo />
                <Metrics />
                <WhyRound />
                <Deal />
                <UseOfFunds />
                <Marquee />
                <Traction />
                <Product />
                <Distribution />
                <Roadmap />
                <Market />
                <Team />
                <DataRoom />
                <NextSteps />
            </main>
            <Footer />
        </div>
    );
}
